import { VERSION } from '~/modules/config';
import { UserTokenService } from '~/modules/services/userTokenService';
import { featureFlagsStore } from '~/modules/stores/feature_flags_store';
import { applyEnrollmentFromUrl } from '~/modules/utilities/orgPickerPilot';
import { applyEnrollmentFromUrl as applySlackPilotEnrollmentFromUrl } from '~/modules/utilities/slackPilot';

console.log(
    `AppExchange v${VERSION} (built on ${new Date(
        bundledConfig.BUILD_TIMESTAMP,
    ).toLocaleString()}) © Copyright ${new Date().getFullYear()} Salesforce, Inc.`,
);

// Hydrate feature flags
featureFlagsStore.getFeatureFlags({
    defaultValues: window.stores?.FEATURE_FLAGS,
    context: {
        userId: UserTokenService.getUserToken(),
        hostname: window.location.hostname,
    },
});

// Must run before the dynamic import below: boot_client.ts statically imports page/container,
// which transitively pulls in routerStore.ts before boot_client's own body runs, and routerStore
// reads org-picker enrollment (via FeatureFlags/localStorage) synchronously at module-load time
// to build its route map.
applyEnrollmentFromUrl();
applySlackPilotEnrollmentFromUrl();

// We must use dynamic import here to ensure feature flags are fully loaded before the client initializes
import('./boot_client');
